import React from "react";
import CommonApi from "shared/enums/CommonApi";
import SocialMediaShare from "shared/components/socialMediaShare";
import useNavigateWrapper from "shared/hooks/useNavigateWrapper";
import { useMyExperienceDashboardDetails } from "../../context/dashboard";
import { MyExpRoute } from "../../routes/types";
import QueryParamKey from "shared/enums/QueryParamKey";
import { useSearchParams } from "react-router-dom";
import { useRegDetail } from "shared/context/regDetail";
import useLogAnalyticsScreenHook from "apps/myExperience/context/analyticsWrapper/hooks/useLogAnalyticsScreenHook";
import { AnalyticsScreenNameEnum } from "shared/enums/AnalyticsEnums";
import { useMyExpAnalytics } from "apps/myExperience/context/analyticsWrapper";

export default function SocialMediaShareHandler() {
  const { logEvent } = useMyExpAnalytics();
  useLogAnalyticsScreenHook({ properties: { screenType: AnalyticsScreenNameEnum.POST_ON_SOCIAL_MEDIA } });
  const [searchParams] = useSearchParams();
  const navigation = useNavigateWrapper();
  const { data: dashboardData } = useMyExperienceDashboardDetails();
  const { socialMediaTemplateText = "" } = useRegDetail();

  const headshotUploadHandler = React.useCallback(
    activeTemplateId => {
      if (activeTemplateId) {
        searchParams.set(QueryParamKey.SOCIAL_MEDIA_TEMPLATE_ID, activeTemplateId);
      }
      navigation.navigate({
        pathname: `/${MyExpRoute.UPDATE_PROFILE_PIC.path}`,
        search: searchParams.toString()
      });
    },
    [navigation, searchParams]
  );

  return (
    <SocialMediaShare
      shareText={socialMediaTemplateText}
      listApi={CommonApi.FIND_SOCIAL_TEMPLATES_BY_REG}
      regParticipantId={dashboardData?.registrationParticipantId}
      onClose={() => navigation.navigate(MyExpRoute.HOME.path)}
      headshot={dashboardData?.profilePictureLocation}
      handleHeadshotUpload={headshotUploadHandler}
      participantData={{
        firstName: dashboardData.firstName,
        lastName: dashboardData.lastName,
        jobTitle: dashboardData.jobTitle,
        organization: dashboardData.registrationOrganizationName
      }}
      logEvent={logEvent}
    />
  );
}
